import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend) // загружает переводы через HTTP
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('lng') || 'ru',  // язык по умолчанию
    fallbackLng: 'ru',
    debug: false, // включи true для отладки

    ns: ['header'],              // используемые неймспейсы
    defaultNS: 'header',         // неймспейс по умолчанию

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'  // путь к JSON-файлам
    },

    interpolation: {
      escapeValue: false // react сам экранирует
    }
  });

export default i18n;
